import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// The practice loop's keyframes, shared with the other app that
// renders the same loop. See packages/ui/src/styles/practice-loop.css.
import "@lyder-talk/ui/styles/practice-loop.css";
import { redirectSignedInVisitor } from "./lib/signed-in-redirect";

// Before anything renders: someone who is already signed in and opens the
// landing page belongs in the app, not on the marketing page. See
// ./lib/signed-in-redirect.ts.
if (!redirectSignedInVisitor()) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
